export const SET_APP_TOUR_PROGRESS = 'app-tour/set-app-tour-progress';
export const SET_APP_TOUR_LAST_STEP = 'app-tour/set-app-tour-last-step';
export const CLEAR_APP_TOUR_PROGRESS = 'app-tour/clear-app-tour-progress';
export const SET_TOUR_CREATED_PAGE = 'app-tour/set-tour-created-page';
export const SET_PUBLISH_STATUS = 'app-tour/set-publish-status';
export const SET_WIZARD_ENABLED = 'app-tour/set-wizard-enabled';
export const SET_EXISTING_PAGES = 'app-tour/set-existing-pages';
export const SET_WIZARD_CAN_BE_SHOWN = 'app-tour/set-wizard-can-be-shown';
